import { AccountingConnectorType } from '../../../src/types/accountingConnector';

const accountingConnectorMaxNameLengthMapper = new Map([
	['agiris-axe', 30],
	['agiris-fidorg', 30],
	['cegid', 35],
]);

export const getAccountingConnectorMaxNameLength = (accountingConnectorCode: AccountingConnectorType['code']) =>
	accountingConnectorMaxNameLengthMapper.get(accountingConnectorCode);
